module.exports = __webpack_public_path__ + "img/utc2d_red.543db2ca.png";